import { normalizeLedgerUsername } from './daisySeal';

const SHIELD_PATH =
  'M 2 16 A 14 14 0 0 1 16 2 L 24 2 A 14 14 0 0 1 38 16 L 38 32 A 14 14 0 0 1 24 46 L 16 46 A 14 14 0 0 1 2 32 Z';

export { SHIELD_PATH };

export function getLedgerAvatarCrop(username: string): { y: string; height: string } {
  const normalizedUser = normalizeLedgerUsername(username);
  if (normalizedUser === 'pr_tek' || normalizedUser === 'rachoon' || normalizedUser === 'mapster') {
    return { y: '1.5', height: '51' };
  }
  if (username === 'Coach_2' || normalizedUser === 'joni') {
    return { y: username === 'Coach_2' ? '-1.5' : '-7', height: '60' };
  }
  if (
    normalizedUser === 'trimbawolf' ||
    normalizedUser === 'borneo2run' ||
    normalizedUser === 'barry' ||
    normalizedUser === 'quark'
  ) {
    return { y: '1.9', height: '60' };
  }
  return { y: '2', height: '44' };
}
